import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgLabelDirective } from './pg-label/pg-label.directive';

import { PgSpinnerModule } from '../pg-spinner/pg-spinner.module';
import { PgIconModule } from '../pg-icon/pg-icon.module';

@NgModule({
  declarations: [PgLabelDirective],
  imports: [CommonModule, PgSpinnerModule, PgIconModule],
  exports: [PgLabelDirective],
})
export class PgContentBlocksModule {}
